import useIsMobile from '@/hooks/useIsMobile';
import { breakpoints } from '@/styles/breakpoints';

import * as S from './style';

const SideButton = () => {
	const isMobile = useIsMobile(breakpoints.layout);
	const scrollToTop = () => {
		window.scroll({
			top: 0,
			behavior: 'smooth',
		});
	};

	return (
		<S.ButtonBox>
			<S.Button type="button" onClick={scrollToTop}>
				<svg width={!isMobile ? '40' : '20'} height={!isMobile ? '40' : '20'} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M8.57031 24.8997L19.1527 14.3173C19.6214 13.8486 20.3812 13.8486 20.8498 14.3173L31.4322 24.8997"
						stroke="white"
						strokeWidth="2"
						strokeLinecap="round"
					/>
				</svg>
			</S.Button>
		</S.ButtonBox>
	);
};

export default SideButton;
